// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InputGroup-base__VXtnw{position:relative;display:flex;flex-direction:column;gap:var(--size-2);align-items:flex-start}.InputGroup-inputGrouped__Uipj4{flex:1 1 0;min-width:0;margin-left:-1px}.InputGroup-inputs__sJujF{display:flex;flex-wrap:nowrap;gap:0;align-items:flex-start !important;width:var(--size-full);border-radius:var(--border-radius-1_5);box-shadow:var(--box-shadow-xs-down)}.InputGroup-hiddenInput__PnwbC{position:absolute;top:0;left:0;display:none;width:0;height:0;opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "InputGroup-base__VXtnw",
	"inputGrouped": "InputGroup-inputGrouped__Uipj4",
	"inputs": "InputGroup-inputs__sJujF",
	"hiddenInput": "InputGroup-hiddenInput__PnwbC"
};
export default ___CSS_LOADER_EXPORT___;
